/* 2026 Diwali Theme: sold-out gift box touches. Data comes from Liquid in sections/header-group.json */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    /* Home page: mark sold-out tiles in the Diwali banner */
    var so = String(window.TF_SOLDOUT || '').split(',').filter(Boolean);
    if (so.length) {
      document.querySelectorAll('.tf-dw__card').forEach(function (c) {
        var handle = (c.getAttribute('href') || '').split('?')[0].split('/products/')[1];
        if (!handle || so.indexOf(handle) === -1) return;
        c.classList.add('is-soldout');
        var cta = c.querySelector('.tf-dw__cp i');
        if (cta) cta.textContent = 'Sold out';
        var img = c.querySelector('.tf-dw__img');
        if (img && !img.querySelector('.tf-so')) {
          var tag = document.createElement('em');
          tag.className = 'tf-so';
          tag.textContent = 'Sold out';
          img.appendChild(tag);
        }
      });
    }
    /* Gift box page: show a sold-out notice instead of an empty box builder */
    var tpl = document.getElementById('tf-soldbn-tpl');
    var hero = document.querySelector('.tf-bx__hero');
    if (tpl && hero && !document.querySelector('.tf-soldbn')) {
      hero.insertAdjacentHTML('afterend', tpl.innerHTML);
      document.body.classList.add('tf-boxsold');
      var pts = document.querySelector('.tf-bx__pts');
      if (pts) {
        pts.querySelectorAll('li').forEach(function (li) {
          if (/order by|ships in/i.test(li.textContent)) li.remove();
        });
        pts.insertAdjacentHTML('beforeend', '<li>Pre-orders closed &ndash; thank you!</li>');
      }
    }
  });
})();
